import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAssetById } from '@api/map';

import QueryClientService from '@utils/queryClientService';

import { TAssetProfile } from '@interfaces/assets/asset';

import { ASSET } from '@constants/queryKeys';

export const useQueryAssetById = (id?: string, isProfile?: boolean) => {
	const queryClient = useQueryClient();
	const { markerType } = useAppSelector(map);

	const prefetchAsset = async (id: string) => {
		try {
			const assetQuery = QueryClientService.queryClient.getQueryCache().find([ASSET, id, markerType]);

			if (assetQuery) {
				return;
			}

			await queryClient.prefetchQuery({
				queryKey: [ASSET, [id], markerType],
				queryFn: () => Promise.all([getAssetById(id)]),
			});
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e);
		}
	};

	const {
		data: assetById,
		isInitialLoading,
	} = useQuery<TAssetProfile>({
		queryKey: [ASSET, id],
		enabled: [!!id, isProfile],
		queryFn: () => getAssetById(id),
		refetchOnWindowFocus: false,
	});

	return {
		prefetchAsset,
		assetById,
		isLoadingAssetById: isInitialLoading,
	};
};
